export default __webpack_public_path__ + "static/media/11.69dbf761.png";